import { combineReducers } from 'redux';

import { LOGOUT_SUCCESS } from 'Store/constants';

import userAgentReducer from './userAgentReducer';

// main page
import teamCardReducer from './teamCardReducer';
import leagueCardReducer from './leagueCardReducer';
import homeReducer from './homeReducer';
import modalReducer from './modalReducer';

// throwback coupon reducer
import throwbackCouponReducer from './throwbackCouponReducer';

// cms reducer
import cmsReducer from './cmsReducer';

//Match Card
import matchCardReducer from './MatchCard';

//SportsBook
import sportsBookReducer from './SportsBook';
import favoriteEventsReducer from './favoriteEventsReducer';

//Betslip
import betSlipReducer from './BetSlip/betSlipReducer';
import playCouponReducer from './BetSlip/playCouponReducer';
import saveCouponReducer from './BetSlip/saveCouponReducer';

//Membership
import authReducer from './authReducer';
import membershipReducer from './Membership';
import campaignListReducer from './campaignListReducer';
import campaignDetailReducer from './campaignDetailReducer';

//live score
import liveScoresReducer from './LiveScores';

//live stream
import liveStreamReducer from './liveStreamReducer';

//spor toto
import sporTotoReducer from './SporToto';

// Raffle
import raffleReducer from './Raffle';

// Lottery
import lotteryReducer from './Lottery';

// account
import bankAccountReducer from './Account/Finance/bankAccountReducer';
import bankTransactionReducer from './Account/Finance/bankTransactionReducer';
import paymentRequestReducer from './Account/Finance/paymentRequestReducer';
import depositReducer from './depositReducer';
import withdrawMoneyReducer from './Account/withdrawMoneyReducer';
import balanceHistoryReducer from './Account/balanceHistoryReducer';
import withdrawInfoReducer from './Account/withdrawInfoReducer';

//communication settings
import communicationSettingsReducer from './communicationSettingsReducer';

//announcement
import announcementReducer from './announcementReducer';
//personal informations
import personalInformationsReducer from './personalInformationsReducer';
//contactUs
import contactUsReducer from './ContactUs';

//coupons
import couponsReducer from './Coupons';
//Super System
import superSystemReducer from './SuperSystem';

// scores
import eventScoresReducer from './eventScoresReducer';

//Tribun
import tribunReducer from './Tribun';

//Popular Bets
import popularBetsReducer from './popularBetsReducer';
import homePagePopularBetsReducer from './homePagePopularBetsReducer';

//Chance Games
import cgReducer from './ChanceGames';

//Chance Games
import allCategoriesReducer from './allCategoriesReducer';

//Social Cooupon
import socialCouponReducer from './socialCouponReducer';

//Odd History Cooupon
import oddHistoryReducer from './oddHistoryReducer';

//User Information
import giftInformationsReducer from './giftInformationsReducer';

// market reducer
import marketReducer from './marketReducer';

// Communication Permission reducer
import cancelEmailPermissionsReducer from './cancelEmailPermissionsReducer';

// horse Racing reducer
import horseRacingReducer from './HorseRacing';

// rafflev2 reducer
import raffleV2Reducer from './RaffleV2';

// Static Screen reducer
import staticScreenReducer from './staticScreenReducer';
import staticPageReducer from './staticPageReducer';

import sportsBookHashReducer from './SportsBookHash';

//Authors
import authorsReducer from './Authors';
import scratchOffReducer from './ScratchOff';

//multipleCoupon
import multipleCouponReducer from './BetSlip/multipleCouponReducer';

import importantMomentsReducer from './importantMomentsReducer';


import nationalIdReducer from './nationalIdReducer';
import drawerReducer from './drawerReducer';
import sporTotoSocialCouponReducer from './sporTotoSocialCouponReducer';
import userCampaignReducer from './userCampaignReducer';
import xgReducer from './xgReducer';
import vaixSearchReducer from './vaixSearchReducer';
import collapseReducer from './collapseReducer';
import ssrMetaReducer from './ssrMetaReducer';

const appReducer = combineReducers({
  userAgent: userAgentReducer,
  auth: authReducer,
  giftInformations: giftInformationsReducer,
  matchCard: matchCardReducer,
  teamCard: teamCardReducer,
  leagueCard: leagueCardReducer,
  membership: membershipReducer,
  oddHistory: oddHistoryReducer,
  sportsBook: sportsBookReducer,
  sportsBookHash: sportsBookHashReducer,
  home: homeReducer,
  betSlip: betSlipReducer,
  playCoupon: playCouponReducer,
  saveCouponStatus: saveCouponReducer,
  modalData: modalReducer,
  campaignList: campaignListReducer,
  campaignDetail: campaignDetailReducer,
  liveScores: liveScoresReducer,
  liveStream: liveStreamReducer,
  sporToto: sporTotoReducer,
  communicationSettings: communicationSettingsReducer,
  contactUs: contactUsReducer,
  raffle: raffleReducer,
  lottery: lotteryReducer,
  bankAccount: bankAccountReducer,
  bankTransaction: bankTransactionReducer,
  paymentRequest: paymentRequestReducer,
  deposit: depositReducer,
  coupons: couponsReducer,
  socialCoupon: socialCouponReducer,
  personalInformations: personalInformationsReducer,
  announcement: announcementReducer,
  favoriteEvents: favoriteEventsReducer,
  withdrawMoney: withdrawMoneyReducer,
  balanceHistory: balanceHistoryReducer,
  withdrawInfo: withdrawInfoReducer,
  eventScores: eventScoresReducer,
  tribun: tribunReducer,
  cms: cmsReducer,
  superSystem: superSystemReducer,
  popularBets: popularBetsReducer,
  homePopularBets: homePagePopularBetsReducer,
  chanceGames: cgReducer,
  allCategories: allCategoriesReducer,
  throwbackCoupon: throwbackCouponReducer,
  market: marketReducer,
  cancelEmailPermissions: cancelEmailPermissionsReducer,
  staticScreen: staticScreenReducer,
  staticPage: staticPageReducer,
  horseRacing: horseRacingReducer,
  raffleV2: raffleV2Reducer,
  authors: authorsReducer,
  scratchOff: scratchOffReducer,
  multipleCoupon: multipleCouponReducer,
  importantMoments: importantMomentsReducer,
  userNational: nationalIdReducer,
  drawer: drawerReducer,
  sporTotoSocial: sporTotoSocialCouponReducer,
  userCampaign: userCampaignReducer,
  xg: xgReducer,
  vaixSearch: vaixSearchReducer,
  collapse: collapseReducer,
  ssrMeta: ssrMetaReducer
});

export default (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    state = {
      userAgent: state.userAgent,
      betSlip: state.betSlip
    };
  }

  return appReducer(state, action);
};
